import { toArray } from "../utils/primitives";

import { lookupImage } from "./lookupImage";

export function getContextImage(src, context) {
  if (src) {
    const mappedSrc = lookupImage(src, context);
    const allContexts = toArray(context.context) || [];
    for (const ctx of allContexts) {
      try {
        const image = ctx(`./${mappedSrc}`);
        return image.default || image;
      } catch (e) {
        console.debug(e);
      }
    }
    console.warn("Unable to find image: ", mappedSrc);
  }
}
